import { type PropsOf } from '@blaze-runtime/engine-domain';

import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';
import { registerElementDefinition } from '../../services/element-definitions.service';

import {
  getContainerDefaults,
  getContainerSlotDefaults,
  getIoConfig,
  getNavigationContainerPropsConfig,
  getNavigationContainerSlotPropsConfig,
} from './_base-container.element';
import {
  type BaseContainerDef,
  type BaseContainerPropsModel,
  CONTAINER_DEFAULT_HEIGHT,
  CONTAINER_INITIAL_SLOT_ID,
} from './_container.models';
import { ContainerComponent } from './container.component';

export type NavBottombarContainerDef = BaseContainerDef<NavBottombarContainerPropsModel>;

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    navBottombarContainer: NavBottombarContainerDef;
  }
}

export function getNavBottombarContainerDefinition(): CanvasElementDefinition<
  'navBottombarContainer',
  'container'
> {
  return {
    type: 'navBottombarContainer',
    variantOf: 'container',
    componentType: ContainerComponent,
    isListed: false,
    name: 'Navigation Footer',
    width: { mode: 'full' },
    height: { mode: 'value', fixed: false, value: CONTAINER_DEFAULT_HEIGHT },
    slots: {
      ids: [CONTAINER_INITIAL_SLOT_ID],
      [CONTAINER_INITIAL_SLOT_ID]: {
        children: [],
      },
    },
    ioConfig: getIoConfig(),
    propsConfig: getNavigationContainerPropsConfig('navBottombarContainer'),
    slotPropsConfig: () => getNavigationContainerSlotPropsConfig('navBottombarContainer'),
    defaults: getDefaults(),
    slotDefaults: getContainerSlotDefaults(),
    styleIncludePaths: ['style'],
    features: {
      topLevelContainer: true,
    },
    version: 1,
  };
}

registerElementDefinition(getNavBottombarContainerDefinition());

export type NavBottombarContainerPropsModel = BaseContainerPropsModel & {
  content: {
    isSticky?: boolean;
  };
};

function getDefaults(): PropsOf<'navBottombarContainer'> {
  return {
    ...getContainerDefaults(),
    content: {
      isSticky: true,
    },
  };
}
